module.exports = __webpack_public_path__ + "static/img/jieshao.14392f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/jieshao.jpg
// module id = lKV/
// module chunks = 6